import { useNewOfferExpenses, useSolarPackages } from '~src/hooks/services';

export const useCombinePackageWithSolarExpenses = (
  solarPackage?: ReturnType<typeof useSolarPackages>['packages'][number]
) => {
  const { newOfferExpenses } = useNewOfferExpenses();

  const installationExpenses = findSolarInstallationExpenses(solarPackage, newOfferExpenses);

  const otherExpenses = newOfferExpenses?.solar.filter(
    expense => !['solarPanelInstallation', 'inverterInstallation', 'batteryInstallation'].includes(expense.type)
  );

  return {
    withInstallation: { ...solarPackage, expenses: [...installationExpenses, ...(otherExpenses ?? [])] },
    withoutInstallation: { ...solarPackage, expenses: [...(otherExpenses ?? [])] },
  };
};

const findSolarInstallationExpenses = (
  solarPackage?: ReturnType<typeof useSolarPackages>['packages'][number],
  expenses?: ReturnType<typeof useNewOfferExpenses>['newOfferExpenses']
) => {
  const { solarPanel, batteries } = solarPackage ?? {};
  const { quantity = 0 } = solarPanel ?? {};

  const { solar = [] } = expenses ?? {};

  const installationTypes = new Set(['inverterInstallation', ...(batteries?.length ? ['batteryInstallation'] : [])]);

  const sortedSolarExpenses = solar.sort((a, b) => (b.minimumProducts ?? 0) - (a.minimumProducts ?? 0));

  const solarPanelExpense = sortedSolarExpenses.find(
    ({ minimumProducts = 0, type }) => quantity >= (minimumProducts ?? 0) && type === 'solarPanelInstallation'
  );

  return [
    ...solar.filter(({ type }) => installationTypes.has(type ?? '')),
    ...(solarPanelExpense ? [{ ...solarPanelExpense, price: (solarPanelExpense.price ?? 0) * quantity }] : []),
  ];
};
